import { Grid, Link, TextField, Typography } from '@mui/material';
import { TaskModel } from 'domains/models/TaskModel';
import { styled } from '@mui/material/styles';
import { observer } from 'mobx-react';
import TaskGradeEditPageStore from '../store/TaskGradeEditStore';
import React from 'react';
import paperIcon from '../../../assets/image/paperIcon.png';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import LinkIcon from '@mui/icons-material/Link';

const ValidationTextField = styled(TextField)({
  '& fieldset': {
    border: 'none',
    borderTop: '1px solid #dddddd',
    borderRadius: '0px',
  },
});

interface Props {
  pageStore: TaskGradeEditPageStore;
  isOpenAssess: boolean;
}
function TaskGradeEditBody(props: Props) {
  const { pageStore } = props;
  const [textCount, setTextCount] = React.useState(0);

  const handleChangeTextField = (e: React.ChangeEvent<HTMLInputElement>) => {
    pageStore.formik.handleChange(e);
    setTextCount(e.target.value.length);
  };

  React.useEffect(() => {
    setTextCount(pageStore.assess?.title?.length || 0);
  }, []);

  const checkUrl = () => {
    if (pageStore.task?.userData?.webLink) {
      if (pageStore.task?.userData?.webLink.startsWith('https:')) {
        return pageStore.task?.userData?.webLink;
      }
    } else {
      if (pageStore.task?.userData?.webUrl.startsWith('https:')) {
        return pageStore.task?.userData?.webUrl;
      }
    }
  };

  return (
    <Grid container style={{ marginTop: '10px' }}>
      <Grid
        container
        alignItems={'center'}
        style={{
          border: '1px solid #dddddd',
          borderRadius: '15px',
          paddingTop: '18px',
          position: 'relative',
        }}
      >
        <Grid container alignItems={'center'} justifyContent={'space-between'} style={{ marginBottom: '10px' }}>
          <Grid
            style={{
              marginLeft: '16px',

              background: '#EBF8F5',
              width: '40px',
              height: '40px',
              borderRadius: '20px',
              textAlign: 'center',
              paddingTop: '10px',

              cursor: 'pointer',
            }}
            onClick={() => {
              pageStore.setIsHTMLOpen(true);
            }}
          >
            <img src={paperIcon} alt='paperIcon' />
          </Grid>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Grid style={{ marginRight: '20px' }}>
              {pageStore.task?.subtype === 'CHAT' && pageStore.task?.userData?.hasAttachment ? (
                <a href={pageStore.task.userData.attachments[0].contentUrl}>
                  <AttachFileIcon />
                </a>
              ) : (
                <></>
              )}
            </Grid>
            <Grid style={{ marginRight: '20px' }}>
              <Link
                href={checkUrl()}
                target='_blank'
                style={{
                  color: '#2281D0',
                }}
                underline='hover'
              >
                <LinkIcon />
              </Link>
            </Grid>
          </div>
        </Grid>

        <Grid style={{ marginLeft: '14px' }}>
          <Grid
            container
            style={{
              width: 'calc(100% - 80)',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '16px',
            }}
          >
            {pageStore.task?.subtype === 'CHAT' ? '' : pageStore.task?.title}
          </Grid>
          <Grid>
            {pageStore.task?.userData?.body?.contentType === 'html' ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: (pageStore.task?.userData?.bodyPreview as any)
                    ? (pageStore.task?.userData?.bodyPreview as any)
                    : (pageStore.task?.userData?.body.content
                        ?.split('<')
                        .filter((el: any) => !el.startsWith('img'))
                        .filter((el: any) => !el.startsWith('div>&nbsp'))
                        ?.join('<') as any),
                }}
                style={{
                  width: 'calc(100% - 80)',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '16px',
                }}
              ></div>
            ) : (
              <Typography>{pageStore.task?.userData?.body?.content}</Typography>
            )}
          </Grid>
        </Grid>

        <ValidationTextField
          rows={4}
          id='message'
          name='message'
          type='text'
          margin='dense'
          InputProps={{
            style: {
              fontSize: '14px',
              lineHeight: '21px',
              fontWeight: 400,
              border: 'none',
            },
          }}
          inputProps={{
            maxLength: 1000,
            style: {
              border: 'none',
            },
          }}
          placeholder={
            props.isOpenAssess
              ? '발전을 위한 미래지향적 조언을 남겨 주세요. 코멘트는 대상자에게 공개됩니다'
              : '평가자인 당신만을 위한 공간입니다. 진솔한 마음 그대로 마음껏 평가해 보세요. 해당 평가는 철저히 보안이 유지되며, 추후 수정하실 수 있습니다(첫 작성 후 1달 이내).'
          }
          error={pageStore.formik.touched.message && Boolean(pageStore.formik.errors.message)}
          helperText={pageStore.formik.touched.message && pageStore.formik.errors.message}
          sx={{
            borderRadius: '15px',
            border: 'none',
          }}
          multiline
          defaultValue={pageStore.assess?.title}
          fullWidth
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeTextField(e)}
        />
      </Grid>

      {/* <TextareaAutosize
            id='message'
            name='message'
            value={pageStore.formik.values.message}
            onChange={pageStore.formik.handleChange}
            helperText={pageStore.formik.touched.message && pageStore.formik.errors.message}
            minRows={8}
            placeholder='발전을 위한 미래지향적 조언을 남겨 주세요. 코멘트는 대상자에게 공개됩니다.'
            style={{ width: 350 }}
          /> */}
      <Grid container justifyContent={'right'} style={{ fontSize: 12, color: '#111111' }}>
        {textCount}/1000
      </Grid>
    </Grid>
  );
}

export default observer(TaskGradeEditBody);
